import React, { useState, useCallback, useEffect, useMemo } from 'react';

import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { Container } from './styles';

import AtendClassificacaoService from '../../services/AtendClassificacaoService';
import AuthService from '../../services/AuthService';
import history from '../../services/history';
import {
  getPageParams,
  errorHandle,
  padLeft,
  calcNaxItemsPage,
  isScreenMobile,
} from '../../util/functions';

import { showMessage } from '../../components/MessageDialog';

import BotaoMenuGrid from '../../components/BotaoMenuGrid';

import AtendimentoClassificacaoCrud from './crud';
import { StateScreen } from '../constants';
import CrudHeader from '../../components/CrudHeader';
import DataTableSp from '../../components/DataTableSp';
import LabelSp from '../../components/LabelSp';
import DropdownSp from '../../components/DropdownSp';
import AtendTopicoClassificadorService from '../../services/AtendTopicoClassificadorService';

export default function AtendimentoClassificacao(props) {
  // useSelectors
  const filterVisible = useSelector(state => state.global.filterVisible);

  // useMemo
  const pageParams = useMemo(() => getPageParams(props.match.params, props.location.search), [
    props.location.search,
    props.match.params,
  ]);

  const filterService = useMemo(() => AtendClassificacaoService.getFilter(), []);

  // useStates
  const toBack = pageParams.toBack || '/atendimentoClassificacoes';

  const [filter, setFilter] = useState(filterService);
  const [atendimentoClassificacoes, setAtendimentoClassificacoes] = useState([]);

  const [pageLimit, setPageLimit] = useState(filterService.limit);
  const [first, setFirst] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSelected, setPageSelected] = useState(0);
  const [funcTimeOut, setFuncTimeOut] = useState();
  const [topicos, setTopicos] = useState([]);

  // useCallbacks

  const calcLimit = useCallback(() => {
    let ret;
    if (filterVisible) {
      ret = calcNaxItemsPage(10, 14, 19);
    } else {
      ret = calcNaxItemsPage(13, 17, 22);
    }
    setPageLimit(ret);
    return ret;
  }, [filterVisible]);

  const handleBuscar = useCallback(
    async (_filter, _page, resetPage = true) => {
      _filter.page = _page || 0;
      _filter.limit = calcLimit();
      try {
        const result = await AtendClassificacaoService.findAll(_filter);
        setAtendimentoClassificacoes(result.items);

        setTotalRecords(result.totalRecords);
        if (resetPage) {
          setFirst(0);
        }
      } catch (err) {
        errorHandle(err);
      }
    },
    [calcLimit]
  );

  function onPage(event) {
    const pagina = event.first / event.rows;
    setPageSelected(pagina);
    setFirst(event.first);
    handleBuscar(filter, pagina, false);
  }

  // useCallbacks
  const excluirRegistro = useCallback(
    async _id => {
      try {
        await AtendClassificacaoService.delete(_id);
        toast.success('Registro excluído com sucesso.');
        handleBuscar(filter);
      } catch (err) {
        errorHandle(err);
      }
    },
    [filter, handleBuscar]
  );
  const loadTopico = useCallback(async () => {
    const r = await AtendTopicoClassificadorService.findAll({
      limit: 999,
    });

    const retorno = r.items.map(e => {
      return {
        label: e.descricao,
        value: e.id,
      };
    });

    setTopicos(retorno);
  }, []);

  const setFilterAndSearch = useCallback(
    async _filterValue => {
      if (JSON.stringify(_filterValue) !== JSON.stringify(filter)) {
        setFilter(_filterValue);

        if (funcTimeOut) {
          clearTimeout(funcTimeOut);
        }
        const func = setTimeout(async () => {
          handleBuscar(_filterValue);
        }, 800);
        setFuncTimeOut(func);
      }
    },
    [filter, funcTimeOut, handleBuscar]
  );

  // functions
  function getTitle() {
    const titleDefault = 'Classificação de Atendimento';
    let titleAdd = '';

    if (pageParams.stateScreen === StateScreen.stSearch) {
      titleAdd = '';
    }
    if (pageParams.stateScreen === StateScreen.stInsert) {
      titleAdd = '(Novo)';
    }
    if (pageParams.stateScreen === StateScreen.stUpdate) {
      titleAdd = `(Alterando Id: ${pageParams.idSelected})`;
    }
    if (pageParams.stateScreen === StateScreen.stView) {
      titleAdd = ` (Visualizando Id: ${pageParams.idSelected})`;
    }

    if (!isScreenMobile()) {
      return `${titleDefault} ${titleAdd}`;
    }

    return titleDefault;
  }

  const confirmaExclusao = useCallback(
    id => {
      showMessage('Confirmação', 'Confirma a exclusão do registro?', idx => {
        if (idx === 1) {
          excluirRegistro(id);
        }
      });
    },
    [excluirRegistro]
  );

  // useEffects
  useEffect(() => {
    if (pageParams.stateScreen === StateScreen.stSearch) {
      handleBuscar(filter, 0, true);
    }
    loadTopico();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffects
  // Responsavel por recalcular a quantidade de registros da grid quando a div do filtro ocultar
  // ou ficar visivel
  useEffect(() => {
    if (pageParams.stateScreen === StateScreen.stSearch) {
      calcLimit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calcLimit]);

  // renders
  return (
    <Container className="container-page page-enter-tab">
      <div className="p-grid">
        <CrudHeader
          title={getTitle()}
          disabledButtonInsert={!AuthService.checkRoles('CHAMADO_TIPO_INSERIR')}
          showButtonFilter={pageParams.stateScreen === StateScreen.stSearch}
          showButtonInsert
          showButtonSearch
          showButtonConfig
          titleFilterDefault="Buscar por Descrição"
          handleFilterDefault={text => {
            filter.descricao = text;
            setFilter({ ...filter, descricao: text });
            handleBuscar(filter);
          }}
          handleClearFilters={() => {
            setFilter({
              ...filter,
              descricao: '',
              idAtendTopicoClassificador: 0,
            });
          }}
          handleButtonInsert={() => history.push('/atendimentoClassificacoes/insert')}
          handleButtonSearch={() => handleBuscar(filter)}
        >
          <div className="p-col-12 p-md-5 p-lg-5 p-fluid">
            <LabelSp>Topico</LabelSp>
            <DropdownSp
              placeholder="Todos"
              showClear
              onChange={e => {
                setFilterAndSearch({ ...filter, idAtendTopicoClassificador: e?.value });
              }}
              options={topicos}
              value={filter.idAtendTopicoClassificador}
            />
          </div>
        </CrudHeader>
        {pageParams.stateScreen === StateScreen.stSearch ? renderSearch() : renderCrud()}
      </div>
    </Container>
  );

  function renderSearch() {
    return (
      <>
        <div className="p-col-12 p-fluid datatable-doc-demo">
          <DataTableSp
            value={atendimentoClassificacoes}
            style={{ marginBottom: '2px' }}
            paginator
            rows={pageLimit}
            lazy
            responsive
            totalRecords={totalRecords}
            first={first}
            onPage={onPage}
          >
            <Column
              field="id"
              body={rowData => padLeft(rowData.id, 6)}
              header="Id"
              className="grid-col-id"
            />

            <Column
              field="topicoDescricao"
              className="grid-col"
              header="Tópico"
              style={{ width: 200 }}
            />
            <Column field="descricao" className="grid-col" header="Descrição" />
            <Column
              field="permiteAlterarDescricao"
              className="grid-col-data grid-col-center"
              header="Alt. Desc."
              body={rowData => (rowData.permiteAlterarDescricao ? 'Sim' : 'Não')}
            />

            <Column
              field="grauComplexidade"
              className="grid-col-id-g grid-col-center"
              header="Complex."
            />

            <Column
              field="tempoEstimado"
              className="grid-col-id-g grid-col-center"
              header="Tempo(min)"
            />

            <Column
              className="gid-col-acoes-35"
              bodyStyle={{ textAlign: 'end' }}
              body={renderButtonOp}
            />
          </DataTableSp>
        </div>
      </>
    );
  }

  function renderButtonOp(rowData) {
    return (
      <BotaoMenuGrid
        handles={[
          () => history.push(`/atendimentoClassificacoes/${rowData.id}?view`),
          () => history.push(`/atendimentoClassificacoes/${rowData.id}`),
          () => confirmaExclusao(rowData.id),
        ]}
        disableds={[
          false,
          !AuthService.checkRoles('ATEND_CLASSIFICACAO_ALTERAR'),
          !AuthService.checkRoles('ATEND_CLASSIFICACAO_EXCLUIR'),
        ]}
      />
    );
  }

  function renderCrud() {
    return (
      <AtendimentoClassificacaoCrud
        idSelected={pageParams.idSelected}
        stateScreen={pageParams.stateScreen}
        onClose={() => {
          history.push(toBack);
          handleBuscar(filter, pageSelected, false);
        }}
      />
    );
  }
}
